import PilotPendingFaqsAPI from 'dashboard/api/pilot/pendingFaqs';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'PilotPendingFaq',
  API: PilotPendingFaqsAPI,
  getters: {
    getRecords: state => state.records,
  },
  actions: types => ({
    async filter({ commit }, { page, sortAttr, queryPayload, search, status }) {
      commit(types.SET_UI_FLAG, { fetchingList: true });
      try {
        const response = await PilotPendingFaqsAPI.filter(
          page,
          sortAttr,
          queryPayload,
          search,
          status
        );
        const records = response.data.payload;
        commit(types.SET, records);
        commit(types.SET_META, response.data.meta);
        commit(types.SET_UI_FLAG, { fetchingList: false });
        return records;
      } catch (error) {
        commit(types.SET_UI_FLAG, { fetchingList: false });
        throw error;
      }
    },
    async approve({ commit }, { id, knowledgeBaseId, faqId }) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await PilotPendingFaqsAPI.approve(
          id,
          knowledgeBaseId,
          faqId
        );
        commit(types.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
    async reject({ commit }, { id, note }) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await PilotPendingFaqsAPI.reject(id, note);
        commit(types.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
    async batchApprove({ commit }, { ids, knowledgeBaseId }) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await PilotPendingFaqsAPI.batchApprove(
          ids,
          knowledgeBaseId
        );
        commit(types.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
    async batchReject({ commit }, { ids, note }) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await PilotPendingFaqsAPI.batchReject(ids, note);
        commit(types.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
    async batchDestroy({ commit }, ids) {
      commit(types.SET_UI_FLAG, { deletingItem: true });
      try {
        const response = await PilotPendingFaqsAPI.batchDestroy(ids);
        commit(types.SET_UI_FLAG, { deletingItem: false });
        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { deletingItem: false });
        throw error;
      }
    },
    async resetToPending({ commit }, { id }) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await PilotPendingFaqsAPI.resetToPending(id);
        commit(types.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
    async resetToRejected({ commit }, { id, note }) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await PilotPendingFaqsAPI.resetToRejected(id, note);
        commit(types.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
    async batchResetToPending({ commit }, ids) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await PilotPendingFaqsAPI.batchResetToPending(ids);
        commit(types.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
    async batchResetToRejected({ commit }, { ids, note }) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await PilotPendingFaqsAPI.batchResetToRejected(
          ids,
          note
        );
        commit(types.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
    async resetPendingFromRejected({ commit }, { id }) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await PilotPendingFaqsAPI.resetPendingFromRejected(id);
        commit(types.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
    async resetApprovedFromRejected({ commit }, { id, knowledgeBaseId }) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await PilotPendingFaqsAPI.resetApprovedFromRejected(
          id,
          knowledgeBaseId
        );
        commit(types.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
    async batchResetPendingFromRejected({ commit }, ids) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        const response =
          await PilotPendingFaqsAPI.batchResetPendingFromRejected(ids);
        commit(types.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
    async batchResetApprovedFromRejected({ commit }, { ids, knowledgeBaseId }) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        const response =
          await PilotPendingFaqsAPI.batchResetApprovedFromRejected(
            ids,
            knowledgeBaseId
          );
        commit(types.SET_UI_FLAG, { updatingItem: false });
        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
  }),
});
